/* eslint-disable */ /**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 * instead, edit its related `.gql` file and recreate it with
 *
 * npm run codegen:connect
 */

import * as Types from '../../types/uconnect';

import { api } from 'app/apis/connect-gql-api';
export type SyncMeetingAttendanceFromZoomMutationVariables = Types.Exact<{
  meetingId: Types.Scalars['UUID']['input'];
}>;

export type SyncMeetingAttendanceFromZoomMutation = {
  __typename?: 'Mutation';
  syncMeetingAttendanceFromZoom: {
    __typename?: 'SyncMeetingAttendanceFromZoomResult';
    matchedCount: number;
    updatedCount: number;
    skippedCount: number;
    matchedParticipants: Array<{
      __typename?: 'MatchedZoomParticipant';
      userKey: string;
      joinTime?: any | null;
      leaveTime?: any | null;
      durationSeconds: number;
    }>;
    unmatchedParticipants: Array<{
      __typename?: 'UnmatchedZoomParticipant';
      name: string;
      email?: string | null;
      joinTime?: any | null;
      leaveTime?: any | null;
      durationSeconds: number;
    }>;
  };
};

export const SyncMeetingAttendanceFromZoomDocument = `
    mutation SyncMeetingAttendanceFromZoom($meetingId: UUID!) {
  syncMeetingAttendanceFromZoom(meetingId: $meetingId) {
    matchedCount
    updatedCount
    skippedCount
    matchedParticipants {
      userKey
      joinTime
      leaveTime
      durationSeconds
    }
    unmatchedParticipants {
      name
      email
      joinTime
      leaveTime
      durationSeconds
    }
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    SyncMeetingAttendanceFromZoom: build.mutation<
      SyncMeetingAttendanceFromZoomMutation,
      SyncMeetingAttendanceFromZoomMutationVariables
    >({
      query: (variables) => ({ document: SyncMeetingAttendanceFromZoomDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
